/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import dagre from 'dagre'
import { Node, Edge } from 'reactflow'
import { CargoOrganogramaResponse } from '../../../../../interfaces'

export function buildReactFlowGraphFromCargos(
  cargos: CargoOrganogramaResponse[]
): { nodes: Node[], edges: Edge[] } {
  const nodes: Node[] = []
  const edges: Edge[] = []
  let cumulativeYOffset = 0

  function getMaxDepth(node: CargoOrganogramaResponse, depth = 1): number {
    if (!node.subordinados || node.subordinados.length === 0) return depth
    return Math.max(...node.subordinados.map(child => getMaxDepth(child, depth + 1)))
  }

  cargos.forEach(root => {
    const depth = getMaxDepth(root)
    const yOffset = cumulativeYOffset
    const nodeLevels: Record<string, number> = {}

    const g = new dagre.graphlib.Graph()
    g.setGraph({ rankdir: 'TB', nodesep: 50, ranksep: 130 })
    g.setDefaultEdgeLabel(() => ({}))

    function traverse(cargo: CargoOrganogramaResponse, parentId?: string, level = 0) {
      const nodeId = cargo.id
      g.setNode(nodeId, { width: 350, height: 100 })
      if (parentId) g.setEdge(parentId, nodeId)
      nodeLevels[nodeId] = level
      cargo.subordinados?.forEach(sub => traverse(sub, nodeId, level + 1))
    }

    traverse(root)

    dagre.layout(g)

    const xs = g.nodes().map(id => g.node(id).x)
    const minX = Math.min(...xs)
    const maxX = Math.max(...xs)
    const width = maxX - minX
    const targetWidth = 1500
    const centerOffsetX = (targetWidth - width) / 2 - minX

    g.nodes().forEach((nodeId: any) => {
      const n = g.node(nodeId)
      const cargoNode = findCargoById([root], nodeId)
      if (!cargoNode) return

      nodes.push({
        id: nodeId,
        type: 'custom',
        data: {
          id: nodeId,
          label: cargoNode.nomeCargo,
          nivel: nodeLevels[nodeId],
          niveisPontuados: cargoNode.niveisPontuados
        },
        position: {
          x: n.x + centerOffsetX,
          y: n.y + yOffset
        },
        width: 350,
        height: 100
      })
    })

    g.edges().forEach(edge => {
      edges.push({
        id: `e${edge.v}-${edge.w}`,
        source: edge.v,
        target: edge.w
      })
    })

    cumulativeYOffset += depth * 120
  })

  return { nodes, edges }
}

function findCargoById(list: CargoOrganogramaResponse[], id: string): CargoOrganogramaResponse | undefined {
  for (const cargo of list) {
    if (cargo.id === id) return cargo
    const found = findCargoById(cargo.subordinados, id)
    if (found) return found
  }
  return undefined
}
